import { ElementRef, Input, OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthorizedRole } from 'src/openapi-gen/models';

@Directive({
    selector: '[appHideIfUnauthorized]',
    standalone: true
})
export class HideIfUnauthorizedDirective implements OnInit {

  @Input() roles: string[];

  constructor(private el: ElementRef, private authorizationService: AuthService) {
  }

  ngOnInit() {
    this.checkIfYouCanSeeIt();
  }

  checkIfYouCanSeeIt() {
    let doesUserHaveAnyRequiredRoles = this.authorizationService.doesUserHaveRole(this.roles as AuthorizedRole[]) === true;
    if (!doesUserHaveAnyRequiredRoles) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
